<template>
	<PABMap height="100%" width="100%" :hideLogos='hideLogos' />
</template>

<script>
	import PABMap from './PABMap.vue'

	export default {
		name: 'App',
		components: {
			PABMap
		},
		data() {
			return {
				hideLogos: false
			}
		},
		created() {
			if (location.search) {
				const regex = new RegExp('[\\?]type=([^&#]*)');
				const results = regex.exec(location.search);
				this.hideLogos = results[1] === 'embedded';
			}
		},
	}
</script>

<style lang="scss">
html,
body,
#cesiumContainer {
	margin: 0;
	padding: 0;
	width: 100%;
	height: 100%;
}
</style>
